import { useBreakpointValue } from "@gemini/core";
import { placeholders } from "./placeholders";
export const useSimilarCarousel = () => useBreakpointValue({
    base: {
        nbItemsDisplayed: 1,
        cardWidth: 280,
        navBarPaddingRight: 1,
        breakpoint: "base",
    },
    xs: {
        nbItemsDisplayed: 1,
        cardWidth: 280,
        breakpoint: "xs",
        navBarPaddingRight: 1,
    },
    sm: {
        nbItemsDisplayed: 2,
        cardWidth: 280,
        breakpoint: "sm",
        navBarPaddingRight: 1,
    },
    md: {
        nbItemsDisplayed: 2,
        cardWidth: 280,
        breakpoint: "md",
        navBarPaddingRight: 2,
    },
    lg: {
        nbItemsDisplayed: 3,
        cardWidth: 304,
        breakpoint: "lg",
        navBarPaddingRight: 0,
    },
    xl: {
        nbItemsDisplayed: 3,
        cardWidth: 294,
        breakpoint: "xl",
        navBarPaddingRight: 0,
    },
    xxl: {
        nbItemsDisplayed: 4,
        cardWidth: 267.5,
        breakpoint: "xxl",
        navBarPaddingRight: 0,
    },
    xxxl: {
        nbItemsDisplayed: 4,
        cardWidth: 274,
        breakpoint: "xxxl",
        navBarPaddingRight: 0,
    },
});
export const usePlaceholders = () => placeholders;
